import React, { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import Router from './routes';
import ThemeConfig from './theme';
import ScrollToTop from './components/ScrollToTop';
import { useAuthContext } from './context/auth_context';

export default function App() {
  const { isAuthenticated } = useAuthContext();

  const routing = useRoutes(Router(isAuthenticated));

  return (
    <ThemeConfig>
      <ScrollToTop />
      {routing}
      {/* <Router /> */}
    </ThemeConfig>
  );
}
